import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export function BriefSection() {
  const { t } = useLang();
  return (
    <section className="relative border-t border-primary/10 bg-cream/60 px-6 lg:px-24">
      <div className="container mx-auto py-16 lg:py-24">
        <Reveal className="mx-auto flex max-w-4xl flex-col items-center text-center">
          {/* Gold seal accent */}
          <span className="mb-7 grid h-12 w-12 place-items-center rounded-full border border-secondary/40">
            <span className="h-2 w-2 rounded-full bg-secondary shadow-[0_0_12px_rgba(212,161,90,0.6)]" />
          </span>

          <p className="font-serif text-2xl leading-relaxed text-primary/85 md:text-3xl">
            {t.brief.pre}
            <span className="text-gold-deep">{t.brief.highlight}</span>
            {t.brief.post}
          </p>

          <span className="mt-8 h-px w-24 bg-gradient-to-r from-transparent via-secondary to-transparent" />
        </Reveal>
      </div>
    </section>
  );
}
